/* eslint-disable max-len */
export const CHANGE_INPUT = 'app/Sso/Consent/CHANGE_INPUT';

export const RESET_CONSENT = 'app/Sso/Consent/RESET_CONSENT';

export const SSO_CONSENT_DEFAULT_ERROR_MESSAGE =
  'An unknown error has occurred. Please try again later.\nFor assistance, contact {{customerServicePhoneNumber}}.';
